import {
  CombinedLeasingObjectDataByMake,
  CombinedLeasingObjectTypesAndMakes,
  LeasingCalculatorCombinedCodesResponse,
  LeasingCalculatorGeneralDataCodes,
} from 'modules/types/LeasingCalculatorCodes';
import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getCombinedLeasingCalculatorCodes = async () => {
  const response =
    await axiosInstance.get<LeasingCalculatorCombinedCodesResponse>(
      `${REACT_APP_API_SERVER_URL}/api/uwt-code/combined-leasing-calculator`,
    );

  return response.data;
};

export const getGeneralDataCodes = async () => {
  const response = await axiosInstance.get<LeasingCalculatorGeneralDataCodes>(
    `${REACT_APP_API_SERVER_URL}/api/uwt-code/general-data-codes`,
  );

  return response.data;
};

export const getCombinedLeasingObjectTypesAndMakes = async () => {
  const response = await axiosInstance.get<
    CombinedLeasingObjectTypesAndMakes[]
  >(`${REACT_APP_API_SERVER_URL}/api/uwt-code/combined-leasing-object-types`);

  return response.data;
};

export const getCombinedLeasingObjectDataByMake = async (makeId: number) => {
  const response = await axiosInstance.get<CombinedLeasingObjectDataByMake[]>(
    `${REACT_APP_API_SERVER_URL}/api/uwt-code/combined-leasing-object-data/${makeId}`,
  );

  return response.data;
};

export const getCalculatorRemainingValue = async (request: any) => {
  const response = await axiosInstance.post<{percentage: number, value: number}>(
      `${REACT_APP_API_SERVER_URL}/api/uwt-code/rest-values`,
      request
  );

  return response.data;
};
